import React from 'react';
import CarouselUtama from './CarouselUtama';
import './CarouselWithText.css';

const CarouselWithtext = () => {
    return (
        <div className="container2 " >
            <CarouselUtama />            
            <div className="centered2">
                {/* <p className="blue f4 ">best school</p>
                <p className="f3 white ">Selamat Datang</p> */}
            </div>
        </div>
            );
}

export default CarouselWithtext;